import { useNavigate } from 'react-router-dom';

export const getMarketplaceReminderDismissedKey = (doctorId) =>
    `marketplaceReminderDismissed_${doctorId}`;

/**
 * Modal post-aprobación para perfil experto (sin prestación clínica).
 * Guía a REDPLIKAPLACE / Mis productos en lugar de Configuración de citas.
 * Solo debe mostrarse si aún no tiene ePayco marketplace confirmado.
 */
const DoctorMarketplaceReminderModal = ({ doctorId, onClose }) => {
    const navigate = useNavigate();

    const dismiss = () => {
        if (doctorId) {
            sessionStorage.setItem(getMarketplaceReminderDismissedKey(doctorId), '1');
        }
        onClose();
    };

    const handleGo = () => {
        dismiss();
        navigate('/doctor/mis-productos');
    };

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-gray-200 p-8 text-center"
                role="dialog"
                aria-modal="true"
                aria-labelledby="marketplace-reminder-title"
            >
                <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-emerald-100 flex items-center justify-center">
                    <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h2 id="marketplace-reminder-title" className="text-xl font-bold text-gray-800 mb-2">
                    ¡Tu perfil ha sido verificado!
                </h2>
                <p className="text-gray-600 text-sm mb-2">
                    Ya haces parte de la comunidad REDPLIKA. Para compartir tu experiencia y ofrecer servicios en REDPLIKAPLACE, activa tu cuenta de ePayco desde Mis productos.
                </p>
                <p className="text-gray-500 text-xs mb-6">
                    Cuando el administrador valide tu ID, podrás crear y publicar tus servicios.
                </p>
                <button
                    type="button"
                    onClick={handleGo}
                    className="w-full py-3 px-4 bg-[#1f94c2] hover:bg-[#1a7ba8] text-white font-semibold rounded-xl transition-colors"
                >
                    Ir a Mis productos
                </button>
                <button
                    type="button"
                    onClick={dismiss}
                    className="mt-3 w-full py-2 px-4 text-gray-600 hover:text-gray-800 text-sm font-medium"
                >
                    Recordármelo después
                </button>
            </div>
        </div>
    );
};

export default DoctorMarketplaceReminderModal;
